import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/index.js';
var _excluded = ["onClick"];

var ActionBar = function ActionBar(_ref) {
  var _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      disabled = _ref.disabled,
      rows = _ref.rows;
  return /*#__PURE__*/React.createElement("div", {
    className: "action-bar"
  }, buttons.map(function (button, index) {
    var onClick = button.onClick,
        buttonProps = _objectWithoutProperties(button, _excluded);

    var onClickWithRows = function onClickWithRows(e) {
      return onClick(e, rows);
    };

    return /*#__PURE__*/React.createElement(Button, _extends({
      fontTheme: "ui-compact",
      onClick: onClickWithRows
    }, buttonProps, {
      key: "button_".concat(index),
      style: "link",
      disabled: disabled || button.disabled
    }));
  }));
};

ActionBar.displayName = "ActionBar";
ActionBar.propTypes = {
  buttons: PropTypes.array,
  disabled: PropTypes.bool
};
export { ActionBar };